<td>{{ "ServiceElement.References" | translate }}</td>
<td>
  @for (reference of subscription().references; track reference.name) {
    <div>{{ reference.name }}: {{ reference.externalId }}</div>
  }
</td>
